import http, {reqDefaultConfig} from "./http";
import {useRequest} from "ahooks";
import {useState} from "react";
import {mediaMatch, toFormData} from "../utils";
import cookies from "../utils/cookies";
import {useDispatch} from "react-redux";
import {setCartCount, setDrawerLogin} from "../reducer/actions";
import {useNavigateTo} from "../hooks/useNavigateTo";
import {useQueryParam} from "../hooks";
import useNotice from "../hooks/useNotice";
import useRequestTokenAuth from "../hooks/useRequestTokenAuth";

const apiPath = {
  mobileno: '/web/login/mobileno'
};

export const useLogout = () => {
  const notice = useNotice();
  const navigateTo = useNavigateTo();
  const dispatch = useDispatch();
  
  const logout = () => {
    notice.loading('加载中...');
    cookies.logout();
    dispatch(setCartCount(0));
    
    setTimeout(() => {
      notice.hide();
      let redirect = window.location.hash.replace('#', '');
      navigateTo(`/login?redirect=${redirect}`);
    }, 300);
  };
  
  return { logout };
};
let loginAfter = {};

export const useMobileno = () => {
  const dispatch = useDispatch();
  const navigateTo = useNavigateTo();
  const [redirect] = useQueryParam('redirect');
  const [, getLoginAfter] = useRequestTokenAuth();
  
  const [query, setQuery] = useState({
    account: '',
    pwd: '',
    // account: '15913187611',
    // pwd: '123456',
    loginType: 1,
    flag: 'login',
  });
  
  const { data, runAsync, error, loading } = useRequest((query) => {
    return http({
      url: apiPath.mobileno,
      method: 'post',
      data: query
    });
  }, {
    manual: true,
    onSuccess: (result, params) => {
      if (result) {
        cookies.setToken(result.data.accessToken.access_token);
        cookies.set('mall-userInfo', result.data.userInfo);
        loginAfter = getLoginAfter();
        if (loginAfter && loginAfter.handle) {
          loginAfter.handle(loginAfter.query);
        }
        dispatch(setDrawerLogin(false));
      }
    },
  });
  
  const loginHandle = async () => {
    const isMdmax = mediaMatch.isMdmax;
    
    let { data } = await runAsync(query);
    
    if (data && !loginAfter.handle) {
      if (redirect) {
        navigateTo(redirect, { replace: true });
      } else {
        // navigateTo('/');
        if (isMdmax) {
          navigateTo('/');
        } else {
          if (cookies.get('MALL') === '7') {
            window.location.reload();
          } else {
            navigateTo('/');
          }
        }
      }
    }
  };
  
  const inputHandle = (e, name) => {
    let res = { ...query };
    res[name] = e.target.value;
    setQuery(res);
  };
  
  return {
    result: data || {},
    loading,
    error,
    query,
    login: loginHandle,
    inputHandle
  };
};

export const regMobileNo = () => {
  const dispatch = useDispatch();
  const navigateTo = useNavigateTo();
  const [redirect] = useQueryParam('my');
  const notice = useNotice();
  
  const [query, setQuery] = useState({
    account: '',
    pwd: '',
    confirmPwd: '',
    verifyCode: '',
    argumentsCheck: true
  });
  
  const { data, runAsync, error, loading } = useRequest((query) => {
    let q = {
      account: query.account,
      mobileno: query.account,
      pwd: query.pwd,
      verifyCode: query.verifyCode,
      flag: 'reg',
    };
    return http({
      url: apiPath.mobileno,
      method: 'post',
      data: q
    });
  }, {
    manual: true,
    onSuccess: (result, params) => {
      if (result) {
        cookies.setToken(result.data.accessToken.access_token);
        cookies.set('mall-userInfo', result.data.userInfo);
        dispatch(setDrawerLogin(false));
        navigateTo('/')
      }
    },
    ...reqDefaultConfig
  });
  
  const regHandle = async () => {
    let { data } = await runAsync(query);
    if (data) {
      notice.success('注册成功');
      setTimeout(() => {
        if (redirect) {
          navigateTo(redirect);
        } else {
          navigateTo('/');
        }
      }, 1000);
    }
  };
  
  const inputHandle = (e, name) => {
    let res = { ...query };
    res[name] = e.target.value;
    setQuery(res);
  };
  
  return {
    result: data || {},
    loading,
    error,
    query,
    reg: regHandle,
    inputHandle
  };
};
